import { CreateReportRequestGranularityEnum } from "@microtica/ms-cloud-cost-optimizer-sdk";
import { getCostOptimizationService } from "../backend";
import { getProject, getUser } from "./local-storage";

export enum AwsAccountAction {
    CreateUpdate = "CreateUpdate",
    Delete = "Delete"
}
const removeDuplicates = (elements: string[], newElement: string): string[] => {
    return [...new Set([...elements, newElement])];
}

export const handleReport = async (action: AwsAccountAction, projectId: string, awsAccountId: string, awsRegion: string) => {
    const { name: projectName } = getProject();
    const profile = getUser();
    const email = (profile || {}).email;
    const { data: { reports } } = await getCostOptimizationService().listReports(projectId!);
    if (action === AwsAccountAction.CreateUpdate) {
        const foundReport = reports.find(r => r.awsAccountIds.includes(awsAccountId) && r.regions.includes(awsRegion));
        if (foundReport) {
            // report for the provided aws account and region already exists
            return { done: true };
        } else {
            if (!reports.length) {
                // there are no reports for this project
                return getCostOptimizationService().createReport(projectId, {
                    name: `${projectName} report`,
                    awsAccountIds: [awsAccountId],
                    regions: [awsRegion],
                    emails: [email],
                    granularity: CreateReportRequestGranularityEnum.WEEKLY
                })
            } else {
                // report already exists but for diff aws account or region
                const reportToBeUpdated = reports[0];
                return getCostOptimizationService().handleReportEntitiesState(reportToBeUpdated.id, projectId, {
                    awsAccountIds: removeDuplicates(reportToBeUpdated.awsAccountIds, awsAccountId),
                    regions: removeDuplicates(reportToBeUpdated.regions, awsRegion),
                    emails: removeDuplicates(reportToBeUpdated.emails, email)
                });
            }
        }
    }
    if (action === AwsAccountAction.Delete) {
        // Delete logic is moved to ms-engine, so we can also catch the scenario where the user manually deletes the CrossAccountAccess stack
        return {
            done: true
        }
    }
};